<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toctitle"><a id="page_vii"></a>CONTENTS</h1>
<h2 class="toc"><a href="#/xhtml/05_Forword">FOREWORD BY HOWARD NEMEROV</a></h2>
<h2 class="toc"><a href="#/xhtml/06_Preface01">PREFACE TO FIRST EDITION</a></h2>
<h2 class="toc"><a href="#/xhtml/08_Chapter01"><span class="r1">I</span> DEFINITION AND EXAMPLES</a></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter02" title="Link target outside of Sample"><span class="r2">II</span> THE EFFECTS OF POETRY</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter03" title="Link target outside of Sample"><span class="r3">III</span> METAPHOR</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter04" title="Link target outside of Sample"><span class="r3">IV</span> MEANING AND MYTH</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter05" title="Link target outside of Sample"><span class="r2">V</span> LANGUAGE AND POETRY</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter06" title="Link target outside of Sample"><span class="r3">VI</span> THE POET</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter07" title="Link target outside of Sample"><span class="r4">VII</span> THE MAKING OF MEANING (I)</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter08" title="Link target outside of Sample"><span class="r5">VIII</span> THE MAKING OF MEANING (II)</span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter09" title="Link target outside of Sample"><span class="r3">IX</span> VERSE AND PROSE</span></h2>
<h2 class="toc"><span href="#/xhtml/17_Chapter10" title="Link target outside of Sample"><span class="r2">X</span> ARCHAISM</span></h2>
<h2 class="toc"><span href="#/xhtml/18_Chapter11" title="Link target outside of Sample"><span class="r3">XI</span> STRANGENESS</span></h2>
<h2 class="toc"><span href="#/xhtml/19_Chapter12" title="Link target outside of Sample"><span class="r4">XII</span> CONCLUSION</span></h2>
<h2 class="toc"><span href="#/xhtml/20_App01" title="Link target outside of Sample">APPENDIX I</span></h2>
<h2 class="toc"><span href="#/xhtml/21_App02" title="Link target outside of Sample">APPENDIX II</span></h2>
<h2 class="toc"><span href="#/xhtml/22_App03" title="Link target outside of Sample">APPENDIX III</span></h2>
<h2 class="toc"><span href="#/xhtml/23_App04" title="Link target outside of Sample">APPENDIX IV</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?7d9bcffc